var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6285 101.471C44.9254 101.471 52.4254 93.9714 52.4254 84.6746V67.8777H35.6285C26.3317 67.8777 18.8317 75.3777 18.8317 84.6746C18.8317 93.9714 26.3317 101.471 35.6285 101.471Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8317 51.0806C18.8317 41.7837 26.3317 34.2837 35.6285 34.2837H52.4254V67.8774H35.6285C26.3317 67.8774 18.8317 60.3774 18.8317 51.0806Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8317 17.4871C18.8317 8.19019 26.3317 0.690186 35.6285 0.690186H52.4254V34.2839H35.6285C26.3317 34.2839 18.8317 26.7839 18.8317 17.4871Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4254 0.690186H69.2223C78.5192 0.690186 86.0192 8.19019 86.0192 17.4871C86.0192 26.7839 78.5192 34.2839 69.2223 34.2839H52.4254V0.690186Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0192 51.0806C86.0192 60.3774 78.5192 67.8774 69.2223 67.8774C59.9254 67.8774 52.4254 60.3774 52.4254 51.0806C52.4254 41.7837 59.9254 34.2837 69.2223 34.2837C78.5192 34.2837 86.0192 41.7837 86.0192 51.0806Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.081604 0.690186)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.c8c3f4861166056f8b16c08ac1da2579.svg";
export { ForwardRef as ReactComponent };